import "./App.css";
import AppRouters from "./Router";

function App() {
    return (
        <div className="App">
            <AppRouters/>
        </div>
    );
    
}


export default App;

